import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const RotatingHeroText = ({ data = {} }) => {
  const phrases = data.phrases || [
    'boost productivity',
    'save time',
    'increase revenue',
    'scale faster'
  ];
  const prefix = data.prefix || 'We help you';
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % phrases.length);
    }, 2500);

    return () => clearInterval(interval);
  }, [phrases.length]);

  return (
    <div className="flex items-center justify-center h-full bg-gradient-to-br from-indigo-50 to-purple-50 p-8">
      <div className="text-center max-w-3xl">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-800">
          {prefix}{' '}
          <span className="inline-block" style={{ minWidth: '300px', textAlign: 'left' }}>
            <AnimatePresence mode="wait">
              <motion.span
                key={currentIndex}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
                className="text-purple-600 inline-block"
              >
                {phrases[currentIndex]}
              </motion.span>
            </AnimatePresence>
          </span>
        </h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="mt-6 text-xl text-gray-600"
        >
          {data.subtitle || 'Transform your business today'}
        </motion.p>
      </div>
    </div>
  );
};

export default RotatingHeroText;

